import { useState } from "react";
import { SidebarTab, StyleTab } from "../types";

export function useSidebar() {
	const [sidebarOpen, setSidebarOpen] = useState(true);
	const [activeSidebarTab, setActiveSidebarTab] =
		useState<SidebarTab>("settings");
	const [activeStyleTab, setActiveStyleTab] = useState<StyleTab>("ui");

	return {
		sidebarOpen,
		setSidebarOpen,
		activeSidebarTab,
		setActiveSidebarTab,
		activeStyleTab,
		setActiveStyleTab,
	};
}
